
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label ,FormGroup, Button, CardTitle, Spinner} from "reactstrap";
import Breadcrumb from '../Common/Breadcrumb';
import TableContainer from '../Common/TableContainer';
import axios from '../../axios';
import Select from 'react-select'
import { useRef } from 'react';
import moment from 'moment';
import numeral from 'numeral'
import _ from 'lodash'
import SweetAlert from "react-bootstrap-sweetalert";

import * as Xl from 'excel4node'
import FileSaver from "file-saver";
import { Backdrop, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    display:'flex',
    flexDirection:'column',
  
  },
}));
    const BookedOrder=()=>{

        //tabledata
        const[tabledata,settabledata]=useState([])

       //shipmodevalue
        const [shipmodevalue,setshipmodevalue]=useState({label:"All", value:"All"})

        //ordertypevalue
        const[ordertypevalue,setordertypevalue]=useState({label:"All", value:"All"})

        //date
        const [fromdate, setfromdate] = useState(new Date())
        const [todate, settodate] = useState(new Date())
        
        //companyhelp
        const [companyhelp,setcompanyhelp]=useState([])
       const [Companyvalue, setCompanyvalue] = useState({})

        const [showTable, setShowTable] = useState(false);

        //buyerhelp
        const [buyerhelp,setbuyerhelp]=useState([])
        const[buyervalue,setbuyervalue]=useState({label:"All", value:"0"})

        //stylehelp
        const[stylehelp,setstylehelp]=useState([])
        const[stylevalue,setstylevalue]=useState({label:"All", value:"All"})

        //total sum
        const totalQty = _.sumBy(tabledata, 'qty');
        const [datetype, setdatetype] = useState(true)
        const totalininr=_.sumBy(tabledata,'valueinINR')

        //datanotfoundpopup
        const [notfoundpopup, setnotfoundpopup] = useState(false)

        const classes = useStyles();
        const [Spinner1, setSpinner1] = useState(false)
        // //exceldate
        // const [excelshipdate, setexcelshipdate] = useState()
        // const [excelordate, setexcelordate] = useState()
        
        //date
        // var curr = new Date();
        // curr.setDate(curr.getDate() - curr.getDate()+1);
        // var date = curr.toISOString().substring(0,10);

        // var curr=new Date()
        // curr.setDate(curr.getDate())
        // var date1 = curr.toISOString().substring(0,10);

        //Ordertype Options
        const Ordertypeoption=[
            {label:"Bulk",value:"B"},
            {label:"Sample",value:"S"},
            {label:"All",value:"All"}

        ]
        //ShipMode Options
        const ShipModeoption=[
            {label:"Sea",value:"Sea"},
            {label:"Air",value:"Air"},
            {label:"All",value:"All"}
        ]
        // console.log(ShipModeoption,"yuki")
        const column = useMemo(
            () => [
              {
                Header: "Company",
                accessor:(row=>(<div className='text-start'>{row.company}</div>)),
                filterable: false,
        
              },
              {
                Header: "Buyer",
                // accessor:(row=>(<div className='text-start'>{row.buyer}</div>)),
                accessor:'buyer',
                filterable: false,
        
              },
              {
                Header: "Ipo No",
                accessor: (row=>(<div className='text-end'>{row.ipoNo}</div>)),
                filterable: false,
        
              },
              {
                Header: "Style",
                accessor: (row=>(<div className='text-start'>{row.style}</div>)),
                filterable: false,
        
              },
              {
                Header: "Order No",
                accessor: (row=>(<div className='text-end'>{row.orderNo}</div>)),
                filterable: false,
              },
              {
                Header: "Order Date",
                accessor: (row)=>(
                  (moment(row.orderDt).format("DD-MM-yyyy"))
                ),
                filterable: false,
               
              },
              {
                Header: "Garments",
              accessor:(row=>(<div className='text-start'>{row.garment}</div>)),
                filterable: false,
              
              },
              {
                Header: "Qty(Pcs)",
                accessor: (row=>(<div className='text-end'>{row.qty}</div>)),
                filterable: false,
              
              },
              {
                Header: "Currency",
                accessor: (row=>(<div className='text-start'>{row.curr}</div>)),
                filterable: false,
              
              },
              {
                Header: "Rate",
                accessor: (row=>(
                  <div className='text-end'>{(numeral(row.rate).format('0.00'))}</div>
                )),
                filterable: false,
              
              },
              {
                Header: "Ex.Rate",
                accessor: (row=>(
                  <div className='text-end'>{(numeral(row.exRate).format('0.00'))}</div>
                )),
                filterable: false,
              
              },
              {
                Header: " Total Value",
                accessor: (row=>(<div className='text-end'>{numeral(row.totalValue).format("0,0.00")}</div>)),
                filterable: false,
              
              },
              {
                Header: " Total Value In INR",
                accessor: (row=>(<div className='text-end'>{numeral(row.valueinINR).format("0,0.00")}</div>)),
                filterable: false,
              
              },
              {
                Header: " Ship Mode",
              accessor:(row=>(<div className='text-start'>{row.shipMode}</div>)),
                filterable: false,
              
              },
              {
                Header: "Ship Date",
                accessor: (row)=>(
                  (moment(row.date).format("DD-MM-yyyy"))
                ),
                filterable: false,
               
              },
            ]
        )
        const data=tabledata
            // buyer:'1',
            // style:'1',
            // orderno:'1',
            // qty:'1',
            // valueinusd:'1',
            // shipdate:'1',
            // shipmode:'1',
          

    
// function Getbuyervaleu(value) {
//     console.log(value,'params')
// }
     const table =async(value) => {
        setShowTable(true);
        setSpinner1(true)
        await axios.instance.get(`/BookedOrder/GetBookedOrderData?buyerId=${buyervalue.value}&style=${stylevalue.value}&OrderType=${ordertypevalue.value}&shipMode=${shipmodevalue.value}&startDate=${moment(fromdate).format('YYYY-MM-DD')}&endDate=${moment(todate).format('YYYY-MM-DD')}&companyid=${Companyvalue.value}&Deliverydate=${datetype ? 'Y' :'N'}`)
        .then((res)=>{
            console.log(res.data)
            
            res.data==""? (settabledata([]) || setnotfoundpopup(true)) : settabledata(res.data)
        })
        setTimeout(() => {
          setSpinner1(false)
        }, 2000);
        handleDownload()
      };

      const ExportToexcel= () => {
        setShowTable(true);
        let Bookedorderdata = []
        const columns = [
          "Company",
          "Buyer",
         " Ipo No",
          "Style",
        "  Order No",
         " Order Date",
          "Rate",
          "Currency",
         " Qty(Pcs)",
         " Total Value In INR",
          "Ship Date",
         " Ship Mode",
          "Grament"
        ]

        data.map((data) => {
         // console.log(data)
         Bookedorderdata.push({
                
                "Company":data.company,
                "Buyer":data.buyer,
               "IpoNo":data.ipoNo.toString(),
                "Style":data.style,
              " OrderNo":data.orderNo,
               " OrderDate":moment(data.oddate).format("DD-MM-yyyy"),
              "  Rate":data.rate.toString(),
                "Currency":data.curr,
               " qty":data.qty.toString(),
               " TotalValueInINR":numeral(data.valueinINR.toString()).format("0,0.00"),
                "ShipDate":moment(data.date).format("DD-MM-yyyy"),
               " ShipMode":data.shipMode,
                "Grament":data.garment
          })
          // console.log(Bookedorderdata,"excel")
        })
        const wb = new Xl.Workbook();
        const ws = wb.addWorksheet('Booked Order'); 
        
        var headings = wb.createStyle({
          font: {
              bold: true,
              size: 12,
              vertAlign: 'center',
              width:20
          },
          alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true
          },
          border: {
              left: {
                  style: "thin"
              },
              right: {
                  style: "thin"
              },
              top: {
                  style: "thin"
              },
              bottom: {
                  style: "thin"
              }
          },
          fill: {
              type: 'pattern',
              patternType: 'solid',
              fgColor: '#ddd9c3'
          }
      });


      var headingLeft = wb.createStyle({
        font: {
            bold: false,
            size: 12,
            vertAlign: 'center'
        },
        alignment: {
            horizontal: 'left',
            vertical: 'center',
            wrapText: true
            
        },
        border: {
            left: {
                style: "thin"
            },
            right: {
                style: "thin"
            },
            top: {
                style: "thin"
            },
            bottom: {
                style: "thin"
            }
        }
      })
    var headingRight = wb.createStyle({
      font: {
          bold: false,
          size: 12,
          vertAlign: 'center'
      },
      alignment: {
          horizontal: 'right',
          vertical: 'center',
          wrapText: true
          
      },
      border: {
          left: {
              style: "thin"
          },
          right: {
              style: "thin"
          },
          top: {
              style: "thin"
          },
          bottom: {
              style: "thin"
          }
      }
    })
        // ws.cell(1, 1)


        // .string("Thaniga").style(headings)
        ws.row(8).freeze()
        
        ws.cell(1, 1, 1, 15, true).string("Booked Order").style(headings)

        ws.cell(3,1).string("Company").style(headings)
        ws.cell(3,2).string(Companyvalue.label).style(headings)

        ws.cell(3,4).string("Buyer").style(headings)
        ws.cell(3,5).string(buyervalue.label).style(headings)

        ws.cell(3,7).string("Style No").style(headings)
        ws.cell(3,8).string(stylevalue.label).style(headings)

        ws.cell(3,10).string("Order Type").style(headings)
        ws.cell(3,11).string(ordertypevalue.label).style(headings)

        ws.cell(5,1).string("Ship Mode").style(headings)
        ws.cell(5,2).string(shipmodevalue.label).style(headings)

        ws.cell(5,4).string("From Date").style(headings)
        ws.cell(5,5).string(moment(fromdate).format("DD-MM-yyyy")).style(headings)

        ws.cell(5,7).string("To Date").style(headings)
        ws.cell(5,8).string(moment(todate).format("DD-MM-yyyy")).style(headings)

        let headingColumnIndex = 1;
        columns.forEach(heading => {
          ws.column(headingColumnIndex).setWidth(30);
          ws.cell(8, headingColumnIndex++)
          .string(heading).style(headings)   
        }); 

    var heading1 = wb.createStyle({
      font: {
          bold: false,
          size: 12,
          vertAlign: 'center'
      },
      alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true
          
      },
      border: {
          left: {
              style: "thin"
          },
          right: {
              style: "thin"
          },
          top: {
              style: "thin"
          },
          bottom: {
              style: "thin"
          }
      }
    })

    
    let rowIndex = 9;
    Bookedorderdata.forEach( record => {
      let columnIndex = 1;
      Object.keys(record ).forEach(columnName =>{
         ws.column(columnIndex).setWidth(30);

         columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 6 || columnIndex === 8 || columnIndex === 11 || columnIndex === 12 || columnIndex === 13 ?
         ws.cell(rowIndex,columnIndex).style(headingLeft) :
         ws.cell(rowIndex,columnIndex).style(headingRight)
        
          ws.cell(rowIndex,columnIndex++)
              .string(record [columnName])
      });
      rowIndex++;
    });

    ws.cell(9+Bookedorderdata.length,1,9+Bookedorderdata.length,6,true).string('Total').style(headings)
    ws.cell(9+Bookedorderdata.length, 7 ).string(`${numeral(data.reduce((accumulator, object,) => {
      return accumulator +object.rate  }, 0)).format('0,0.00')}`).style(headingLeft)
    ws.cell(9+Bookedorderdata.length, 8 ).string('').style(headings)
    ws.cell(9+Bookedorderdata.length, 9 ).string(`${numeral(data.reduce((accumulator, object,) => {
      return accumulator +object.qty  }, 0)).format('0,0.00')}`).style(headingLeft)
    ws.cell(9+Bookedorderdata.length, 10 ).string(`${numeral(data.reduce((accumulator, object,) => {
      return accumulator +object.valueinINR }, 0)).format('0,0.00')}`).style(headingLeft)
    ws.cell(9+Bookedorderdata.length, 11 ).string('').style(headings)
    ws.cell(9+Bookedorderdata.length, 12 ).string('').style(headings)
    ws.cell(9+Bookedorderdata.length, 13 ).string('').style(headings)


        wb.writeToBuffer().then(function(buffer) {
          //console.log(buffer)
          const data = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
          //console.log(datas)
           
        FileSaver.saveAs(data,  'BookedOrder' + ".xlsx")
        });
        setTimeout(() => {
          setSpinner1(false)
        }, 2000);
      }

    useEffect(()=>{
        company()
        buyer()
        //style()
      
        var date =  new Date()
      
        var firstday =  new Date(date.getFullYear(), date.getMonth(),1)
       
        var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
        setfromdate(moment(firstday).format('YYYY-MM-DD'))
        settodate(moment(lastday).format('YYYY-MM-DD'))
        setCompanyvalue(JSON.parse(localStorage.getItem('company')))
    },[])

    const company=async()=>{
        await axios.instance.get("CompanyHelp/GetCompany")
        .then((res)=>{

            const data=res.data
            const option=data.map(row=>({
                "label":row.company,
                "value":row.companyId
            }))
            console.log(option,"companyhelp");
            setcompanyhelp(option)  
        }) 
    }
  
    const buyer=async()=>{
        await axios.instance.get("/BuyerHelp/BookedBuyerHelp")
        .then((res)=>{
            const data =res.data
            const option=data.map(row=>({
                "label":row.buyer,
                "value":row.buyerId
            }))
            console.log(option,"buyerhelp")
            option.push({"label":"All",
            "value":"0"})
            setbuyerhelp(option)
        })
    }

    const style=async(value)=>{
      await axios.instance.get(`/StyleNoHelp/BookedOrderStyleHelp?buyerid=${value}`)
      .then((res)=>{
          const data =res.data
          // console.log(res.data)
          
          const option=data.map(row=>({
              "label":row.style,
                "value":row.style
          }))
          console.log(option,"stylehelp")
          option.push({label:"All",value:"All"})
          setstylehelp(option)
      })
    }

    // const bookedorder=async(value)=>{
    //     const fromDate = fromDateRef.current.value;
    //     const toDate= toDateRef.current.value;
    //     await axios.instance.get(`/BookedOrder/GetBookedOrderData?buyerId=${buyervalue.value}&style=${stylevalue.value}&shipMode=${ShipModeoption.value}&startDate=${fromDate}&endDate=${toDate}`)
    //     .then((res)=>{
    //         console.log(res.data)
    //     })
        
    // }
    const handleDownload = async() => {
   const value =   await axios.instance.get(`/BookedOrder/ExportToExcel?buyers=${buyervalue.label}&companys=${Companyvalue.label}&buyerId=${buyervalue.value}&style=${stylevalue.value}&OrderType=${ordertypevalue.value}&shipMode=${shipmodevalue.value}&startDate=${moment(fromdate).format('YYYY-MM-DD')}&endDate=${moment(todate).format('YYYY-MM-DD')}&companyid=${Companyvalue.value}&Deliverydate=${datetype ? 'Y' :'N'}`, { responseType: 'blob' })
           .then(response => {
               const url = window.URL.createObjectURL(new Blob([response.data]));
              // window.open(response.data, '_blank');
           
               const link = document.createElement('a');
              // link.href = url;
              // link.setAttribute('download', 'Booked Order.xlsx');
             //  document.body.appendChild(link);
             //  window.open(link)
               link.click();

              
           })
          // window.open(value)
           .catch(error => {
               console.error('Error downloading Excel file:', error);
           });
   };


   const ExporttoExcelConsolidate = async() => {
    // await  axios.instance.get('/GetDepartmentSalarySummary', { responseType: 'blob'})
         
     // .then((res) => {
        // const xlBlob = new Blob([res.data] ,{type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'})
        // FileSaver.saveAs(xlBlob , `${fileName}.xlsx`)
   //         localStorage.setItem('pdf', pdfBlob)
   //const value = BookedOrder;
  //  var date =  new Date()


   const now = new Date();
  const year = now.getFullYear();
  const month = now.toLocaleString('default', { month: 'long' });
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  const amPm = hours >= 12 ? 'PM' : 'AM';
  const date =(`${month}_${day}_${year}_${hours}_${minutes}_${amPm}`)
  console.log(date)
 await window.open(`http://103.27.85.36/ExcelFilewebmins/BookedOrder_${date}.xlsx`)
 // await window.open(`http://192.168.1.2/Wbei/ExcelFile/BookedOrder_${date}.xlsx`)

      // })
   }
   
  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5 m-3 pt-sm-5">
      <div  style={{justifyContent:'center', alignItems:'center'}}>
          <div>  
            <Backdrop  open={Spinner1} className={classes.backdrop} >
              <Spinner>
                Loading...
              </Spinner>
            </Backdrop> 
          </div>
      </div>
        <Container fluid={true}>
           <Card style={{backgroundColor:"white"}}>
                <CardBody>
                    <Row>
                      <Col>
                        <Breadcrumb title="Report" breadcrumbItem="Booked Order" />
                      </Col>
                    </Row>
                    <Row>
                        <Col sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='excompany'>
                                    Company
                                </Label>         
                                {/* <select className="form-control" id='excompany' name='company' type='select'  >
                                    <option>--Select--</option>
                                    {/* <option>{helpdata}</option>
                                </select> */}
                                <Select 
                                     value={Companyvalue}
                                    onChange={(value) => {
                                        console.log(value.value)
                                        setCompanyvalue(value)
                                        // Getbuyervaleu(value.value)
                                        // localStorage.setItem('company',JSON.stringify(value))
                                    }}
                                    options={companyhelp}
                                    styles={{
                                        menuPortal: (provided, state) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                        menu: (provided, state) => ({
                                          ...provided,
                                          height: 'auto',
                                        }),
                                      }}
                                      menuPortalTarget={document.body}
                                      // isDisabled={true}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='exbuyer'>
                                    Buyer
                                </Label>         
                                {/* <Input id='exbuyer' name='Buyer' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    value={buyervalue}
                                    name="Buyer"
                                    onChange={(value)=>{
                                        console.log(value.value,"buyervalue")
                                        setbuyervalue(value)
                                        style(value.value)
                                        // bookedorder(value.value)
                                        console.log(value.value,"stylevalue")
                                    }}
                                    options={buyerhelp}
                                    // styles={{
                                    //     menuPortal: (provided, state) => ({
                                    //       ...provided,
                                    //       zIndex: 9999,
                                    //     }),
                                    //     menu: (provided, state) => ({
                                    //       ...provided,
                                    //       height: 'auto',
                                    //     }),
                                    //   }}
                                    //   menuPortalTarget={document.body}
                                />
                            </FormGroup>
                        </Col>
                        <Col  sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='exstyleno'>
                                    Style No
                                </Label>         
                                {/* <Input id='exstyleno' name='Style No' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    name="Style No"
                                    onChange={(value)=>{
                                        console.log(value.value,"stylevalue")
                                        console.log(value.label,"stylelabel")
                                        setstylevalue(value)
                                    }}
                                    options={stylehelp}
                                    value={stylevalue}
                                    styles={{
                                        menuPortal: (provided, state) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                        menu: (provided, state) => ({
                                          ...provided,
                                          height: 'auto',
                                        }),
                                      }}
                                      menuPortalTarget={document.body}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='exordertype'>
                                    Order Type
                                </Label>         
                                {/* <Input id='exordertype' name=' Order Type' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    name="Order Type" 
                                    id= 'exordertype'
                                    value={ordertypevalue}
                                    options={Ordertypeoption}
                                    onChange={(value)=>{
                                        console.log(value.value,"ordertypevalue")
                                        setordertypevalue(value)

                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col  sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='exshipmode'>
                                Shipmode
                                </Label>         
                                {/* <Input id='exshipmode' name='Shipmode' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    name="Shipmode" 
                                    id= 'exshipmode'
                                    value={shipmodevalue}
                                    // onChange={setSelectedOption}
                                    options={ShipModeoption}
                                    onChange={(value)=>{
                                        console.log(value.value,"shipmodevalue")
                                        setshipmodevalue(value)
                                    }
                                    }
                                    styles={{
                                        menuPortal: (provided, state) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                        menu: (provided, state) => ({
                                          ...provided,
                                          height: 'auto',
                                        }),
                                      }}
                                      menuPortalTarget={document.body}
                                  
                                
                                />
                            </FormGroup>
                        </Col>
                        <Col  sm={1} lg={1} md={1}>
                          <div style={{marginTop:'36px'}}>
                            <Label>
                             Date 
                            </Label>
                            <Input type="checkbox" style={{marginLeft:'5px'}}
                            onChange={(e)=>{
                              setdatetype (e.target.checked)
                            }                             
                            }
                            defaultChecked={datetype}
                            />
                             
                          </div>
                          </Col>
                     
                        <Col  sm={12} lg={3} md={6}>
                            <FormGroup> 
                            {datetype? <Label htmlFor="manufacturerbrand">
                              <b>Ship From Date </b>
                              </Label>: <Label htmlFor="manufacturerbrand">
                              <b>Order From Date </b>
                              </Label>}
                                      
                                <Input value={fromdate} id='exfromdate' name='Date' type='date' 
                                min={"1900-01-01"} maxLength="4" max={ "9999-12-31" }
                                onChange={(e)=> setfromdate(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    
                        <Col  sm={12} lg={3} md={6}>
                            <FormGroup> 
                            {datetype? <Label htmlFor="manufacturerbrand">
                              <b>Ship To Date </b>
                              </Label>: <Label htmlFor="manufacturerbrand">
                              <b>Order To Date </b>
                              </Label>}         
                                <Input id='extodate' value={todate}
                                min={"1900-01-01"} maxLength="4" max={ "9999-12-31" }
                                onChange={(e)=> settodate(e.target.value)}
                                name='ToDate' type='date' />
                            </FormGroup>
                        </Col>
                      
                        <Col  sm={12} lg={3} md={6} style={{marginTop:'30px'}}>
                            {/* <Button color='primary' size='md' className='mx-1' onClick={()=>table()}>View</Button>
                            <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47'}}    className="btn btn-sm btn-primary" onClick={()=>ExporttoExcelConsolidate()}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button> */}
                            <Button size='md' className="mx-1 w-lg" style={{backgroundColor:'#0E21A0',color:'white',fontWeight:'bolder'}} onClick={()=>{table()}}>View</Button>
                          <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47',fontWeight:'bolder'}}    className="btn btn-sm btn-primary w-lg"  onClick={()=>{ExporttoExcelConsolidate()}}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button>

                        </Col>
                        
                    </Row>
                    <Row className='mt-3 mb-3'>
                      <Col sm={12} lg={3} md={6}>
                          {/* {shipedorderdata.map((data,index)=>(
                            <p key={index}>Total Value INR :sumBy{data.valueinInr}</p>

                          ))} */}
                          {/* <p ><span className='text-primary'>Total Qty :</span><div>{numeral(totalQty).format("0,0")}</div></p>  */}
                            <FormGroup> 
                                <Label for='exfromdate'>
                                <span className='text-primary'>Total Qty :</span>
                                </Label>         
                                <Input value={numeral(totalQty).format('0,0.00')} id='totqty' name='totqty' type='text' disabled/>
                            </FormGroup>

                      </Col>
                      <Col sm={12} lg={3} md={6}>
                            {/* <p><span className="text-primary" >Total Value INR : </span><div>{numeral(totalininr).format('0,0.00')}</div> </p>     */}
                            <FormGroup> 
                                <Label for='exfromdate'>
                                <span className='text-primary'>Total Value INR :</span>
                                </Label>         
                                <Input value={numeral(totalininr).format('0,0.00')} id='totqty' name='totqty' type='text' disabled/>
                            </FormGroup>
                      </Col>
                    </Row>
                    {showTable && (
                    <TableContainer
                        columns={column}
                        data={data}
                        isGlobalFilter={true}
                        //isAddCustomer={true}
                        isAddTableBorderStrap={true}
                        //   handleInvoiceClicks={handleInvoiceClicks}
                    />
                    )}
                </CardBody>
           </Card>
        </Container>
      </div>
      { notfoundpopup ? (

        <SweetAlert
          title="No Data Found..."
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent:'center',
            alignItems:'center'
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setnotfoundpopup(false);
          }}
        >
        </SweetAlert>
      ):null}
                  
    </React.Fragment>
  )
}

export default BookedOrder;

// Login.propTypes = {
//   error: PropTypes.any,
//   history: PropTypes.object,
//   loginUser: PropTypes.func,
//   socialLogin: PropTypes.func
// }